import { PropsWithChildren } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Card, CircularProgress, IconButton, ListItem, Tooltip } from '@mui/material';

// import { Box, ListItem } from '/src/components';

export type SidebarItemProps = PropsWithChildren & {
  /**
   * Component title. Displayed in the header
   */
  title: string;
  /**
   * Whether this component is visible
   */
  open: boolean;
  /**
   * Toggles component visibility
   * @returns void
   */
  toggleOpen: () => void;
  /**
   * Show a button in the sidebar item header
   */
  buttonProps?: {
    label: string;
    icon: React.ReactNode;
    tooltip?: string;
    onClick?: () => void;
  };
  /**
   * Tooltip for open/close toggle button
   */
  toggleTooltip?: string;
  /**
   * Shows a loading spinner if false. Defaults to true
   */
  resolved?: boolean;
};

export const SidebarItem: React.FC<SidebarItemProps> = ({
  children,
  title,
  open,
  toggleOpen,
  buttonProps,
  toggleTooltip,
  resolved = true,
}) => {
  return (
    <>
      <Card component="md-card" className="no-margin-bottom md-default-theme">
        <ListItem className="toolbar-div pad-left">
          {buttonProps && (
            <Tooltip title={buttonProps.tooltip || buttonProps.label}>
              <IconButton
                className="float-left md-icon-button"
                aria-label={buttonProps.label}
                onClick={buttonProps.onClick}
              >
                {buttonProps.icon}
              </IconButton>
            </Tooltip>
          )}

          <Box display="flex">{title}</Box>
          <Box display="flex" justifyContent="end" flex={1}>
            <Box component="span" className="float-right">
              <IconButton
                aria-label={toggleTooltip || `Toggle ${title} sidebar item`}
                className="md-icon-button"
                onClick={() => toggleOpen()}
              >
                {open ? (
                  <ExpandLess style={{ color: 'white' }} className="md-icon material-icons" />
                ) : (
                  <ExpandMore style={{ color: 'white' }} className="md-icon material-icons" />
                )}
              </IconButton>
            </Box>
          </Box>
        </ListItem>
        {open &&
          (resolved ? (
            <Box bgcolor="white">{children}</Box>
          ) : (
            <Box
              bgcolor="white"
              display="flex"
              flex="100"
              justifyContent="center"
              alignItems="center"
              className="pad-top-bottom"
            >
              <CircularProgress className="md-primary" md-mode="indeterminate" />
            </Box>
          ))}
      </Card>
    </>
  );
};
